<template>
  <div class="present-sticker-body">
    <div class="present-sticker-body__img" :style="imgStyle">
    </div>
    <div class="present-sticker-body__text">
      В подарок
    </div>
  </div>
</template>


<script>
export default {
  name: "PresentSticker",

  props: {
    imgBlockSize: {
      type: String,
      default: "1rem",
    },
  },

  data() {
    return {
    };
  },

  computed: {
    imgStyle() {
      return {
        "background-image": `url(${require("@/assets/img/misc/gift-pic.svg")})`,
        "--image-block-size": this.imgBlockSize,
      };
    },
  },

}
</script>

<style scoped>
.present-sticker-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  font-weight: 900;
  padding: 0.6250em 1.25em;
  background: linear-gradient(94.11deg, #FC9C97 7.37%, #FFAC7E 100%);
  border-radius: 1.25em;
}

.present-sticker-body__img {
  border-radius: 100%;

  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 80%;

  height: var(--image-block-size);
  width: var(--image-block-size);

  margin-right: 10px;
}


.present-sticker-body__text {
  color: #C01717;
}
</style>
